import React from 'react'
import styled from '@emotion/styled'
import { useIntl } from 'react-intl'
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
} from '@mui/material'
import LockIcon from '../../../../assets/icons/Lock.svg'
import OpenLockIcon from '../../../../assets/icons/OpenLock.svg'
import { ui } from '../../../../utils/uiTokens'

const styles = {
    iconBox: {
        display: 'flex',
        gap: 1,
    },
    dialogTitle: {
        fontWeight: 600,
    },
    dialogActions: {
        m: 2,
    },
}

interface Props {
    title: string
    isActive: boolean
    confirmAction: () => void
}

const UnlockCourseDialog: React.FC<Props> = ({
    title = '',
    isActive = false,
    confirmAction,
}) => {
    const { formatMessage } = useIntl()

    const [open, setOpen] = React.useState(false)

    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <Box ml={1}>
            <Box sx={styles.iconBox}>
                <IconLockButton onClick={() => handleClickOpen()}>
                    <img
                        src={isActive ? OpenLockIcon : LockIcon}
                        alt="edit"
                    />
                </IconLockButton>
            </Box>
            <Dialog
                maxWidth={'sm'}
                fullWidth
                open={open}
                onClose={handleClose}
            >
                <DialogTitle
                    id="responsive-dialog-title"
                    sx={styles.dialogTitle}
                >
                    {formatMessage({ id: 'payAttention' })}
                </DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        {isActive
                            ? formatMessage(
                                  { id: 'deActivateCoursePriceText' },
                                  { value: title },
                              )
                            : formatMessage(
                                  { id: 'activateCoursePriceText' },
                                  { value: title },
                              )}
                    </DialogContentText>
                </DialogContent>

                <DialogActions sx={styles.dialogActions}>
                    <Button onClick={handleClose}>
                        {formatMessage({ id: 'cancel' })}
                    </Button>

                    <Button
                        variant="contained"
                        onClick={() => {
                            confirmAction()
                            handleClose()
                        }}
                    >
                        {formatMessage({ id: 'yes' })}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default UnlockCourseDialog

const IconLockButton = styled(IconButton)`
    display: flex;
    gap: 4px;
    background: ${ui.track};
    border-radius: 10px;
    padding: 4px 8px;
    width: fit-content;
`
